import DeviceService from "../services/device-service";
import CalendarService from "../services/calendar-service";
import GroupService from "../services/group-service";
import CommandService from "../services/command-service";
import DriverService from "../services/driver-service";
import GeofenceService from "../services/geofence-service";
import MaintenanceService from "../services/maintenance-service";
import NotificationService from "../services/notification-service";
import PermissionService from "../services/permission-service";
import PositionService from "../services/position-service";
import ReportService from "../services/report-service";
import ServerService from "../services/server-service";
import UserService from "../services/user-service";
import AttributesComputedService from "../services/attributes-computed-service";
import EventService from "../services/event-service";

const useServices = () => {

    return {
        deviceService: new DeviceService(),
        calendarService: new CalendarService(),
        groupService: new GroupService(),
        commandService: new CommandService(),
        driverService: new DriverService(),
        geofenceService: new GeofenceService(),
        maintenanceService: new MaintenanceService(),
        notificationService: new NotificationService(),
        permissionService: new PermissionService(),
        positionService: new PositionService(),
        reportService: new ReportService(),
        serverService: new ServerService(),
        userService: new UserService(),
        eventService: new EventService(),
        attributesComputedService:  new AttributesComputedService()
    };
};

export default useServices;
